// ============================================
// DEFAULT SETTINGS CONFIGURATION
// ============================================
export const defaultSettings = {
    // 'auto' = follow the OS, with an explicit Display Theme pick overriding (Val, 2026-07-15).
    // getEffectiveTheme() in CRMApp already honours this: any theme other than 'auto' is the
    // user's own choice and wins outright; 'auto' consults autoTheme below. Both defaults had
    // to move together — 'auto' with autoTheme.enabled:false falls through to the 'light'
    // fallback, which is where this started.
    theme: 'auto', // 'light', 'dark', 'custom', or 'auto'
    themeExplicitlySet: false,
    autoTheme: {
        enabled: true,
        mode: 'system', // 'system' or 'time'
        timeBasedSchedule: {
            darkStart: '18:00', // 6 PM
            darkEnd: '06:00' // 6 AM
        }
    },
    customTheme: {
        primary: '#F97316', // Orange-600
        secondary: '#3B82F6', // Blue-600
        background: '#FFFFFF',
        surface: '#F9FAFB',
        text: '#1F2937',
        textSecondary: '#6B7280',
        border: '#E5E7EB',
        success: '#10B981',
        warning: '#F59E0B',
        error: '#EF4444'
    },
    dashboard: {
        dateRange: 'week', // 'today', 'week', '2weeks', '30days', 'month', 'ytd', 'custom'
        customStartDate: null,
        customEndDate: null
    },
    reports: {
        cashFlowEnabled: false,
        profitLossEnabled: false
    },
    appointmentType: 'Appointment', // 'Appointment', 'Booking', or 'Reservation'
    calendar: {
        timeScale: 30, // 15 or 30 minutes
        firstDayOfWeek: 'Sunday', // Sunday or Monday
        showWeekNumbers: false,
        useDynamicColumnWidths: true,
        timeFormat: '12hr', // '12hr' or '24hr'
        showAutosaveNotification: true,
        colorBy: 'staff', // 'staff' or 'service'
        capacityEnabled: false,
        maxAppointmentsPerHour: 3
    },
    services: [
        {
            id: 1,
            name: 'Airport Transfer - Zone 1',
            category: 'Airport Transfers',
            price: 45.00,
            duration: 20,
            description: 'Direct transfer to/from airport - closest zone',
            address: 'Sedan',
            active: true,
            color: '#F59E0B',
            additionalInfo: 'POTENTIAL ADDITIONAL FEES\nSTANDBY/WAIT: @$1.6667/min (After 10min complimentary grace period.)\nADDITIONAL STOP(S): @$10.00/Stop + Mileage + Time\nFUEL SURCHARGE: Included (Subject to change)\nSURCHARGE/CONVENIENCE FEE: Yes, if paying by credit card. Waived if paying by Zelle or Cash.'
        },
        {
            id: 2,
            name: 'Airport Transfer - Zone 2',
            category: 'Airport Transfers',
            price: 55.00,
            duration: 30,
            description: 'Airport transfer - medium distance',
            address: 'Sedan',
            active: true,
            color: '#EF4444',
            additionalInfo: 'POTENTIAL ADDITIONAL FEES\nSTANDBY/WAIT: @$1.6667/min (After 10min complimentary grace period.)\nADDITIONAL STOP(S): @$10.00/Stop + Mileage + Time\nFUEL SURCHARGE: Included (Subject to change)\nSURCHARGE/CONVENIENCE FEE: Yes, if paying by credit card. Waived if paying by Zelle or Cash.'
        },
        {
            id: 3,
            name: 'Airport Transfer - Zone 3',
            category: 'Airport Transfers',
            price: 75.00,
            duration: 45,
            description: 'Airport transfer - extended distance',
            address: 'SUV',
            active: true,
            color: '#DC2626',
            additionalInfo: 'POTENTIAL ADDITIONAL FEES\nSTANDBY/WAIT: @$1.6667/min (After 10min complimentary grace period.)\nADDITIONAL STOP(S): @$10.00/Stop + Mileage + Time\nFUEL SURCHARGE: Included (Subject to change)\nSURCHARGE/CONVENIENCE FEE: Yes, if paying by credit card. Waived if paying by Zelle or Cash.'
        },
        {
            id: 4,
            name: 'City Transfer',
            category: 'Local Transfers',
            price: 35.00,
            duration: 15,
            description: 'Quick city transfer within downtown area',
            address: 'Sedan',
            active: true,
            color: '#10B981',
            additionalInfo: ''
        },
        {
            id: 5,
            name: 'Executive Transfer',
            category: 'Premium Services',
            price: 125.00,
            duration: 60,
            description: 'Premium executive transportation service',
            address: 'Luxury Sedan',
            active: true,
            color: '#8B5CF6',
            additionalInfo: ''
        }
    ],
    products: [
        {
            id: 1,
            name: 'Premium Car Seat',
            category: 'Accessories',
            price: 25.00,
            description: 'High-quality car seat for children',
            active: true
        },
        {
            id: 2,
            name: 'Luxury Gift Basket',
            category: 'Gifts',
            price: 75.00,
            description: 'Premium gift basket for special occasions',
            active: true
        }
    ],
    blockedTimes: [],
    appointmentTemplates: [
        {
            id: 1,
            name: 'Standard Airport Transfer',
            serviceId: 1,
            staffId: 1,
            duration: 20,
            defaultPrice: 45.00,
            notes: 'Standard airport pickup/dropoff'
        },
        {
            id: 2,
            name: 'Executive Service',
            serviceId: 5,
            staffId: 1,
            duration: 60,
            defaultPrice: 125.00,
            notes: 'Premium executive transportation'
        }
    ]
};
